import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Observable, tap } from 'rxjs';
import { MaintenanceMessagesResponse } from '../models/maintenance-messages-response';
import { MaintenanceMessagesApiService } from './maintenance-messages-api.service';

export class LoadMaintanenceMessages {
  public static readonly type = '[Maintanence] Get Maintanence Message';
}

@State<MaintenanceMessagesResponse>({
  name: 'getMaintanenceMessagesState'
})
@Injectable()
export class MaintenanceMessagesState {
  private readonly maintenanceMessagesApiService = inject(MaintenanceMessagesApiService);

  @Selector()
  public static getMaintananceMessage(message: MaintenanceMessagesResponse): MaintenanceMessagesResponse {
    return message;
  }

  @Action(LoadMaintanenceMessages)
  public loadMaintenanceMessages(ctx: StateContext<MaintenanceMessagesResponse>): Observable<MaintenanceMessagesResponse> {
    return this.maintenanceMessagesApiService.getMessage().pipe(
      tap((message: MaintenanceMessagesResponse) => {
        ctx.setState(message);
      })
    );
  }
}
